/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import ItemBrowser from './ItemBrowser';
import ItemBrowserModals from '@broadleaf/admin-components/dist/form/item-browser/components/ItemBrowserModals';
import ItemBrowserProvider from '@broadleaf/admin-components/dist/form/item-browser/providers/ItemBrowserProvider';
export {
  ItemBrowser as Display,
  ItemBrowserModals as Modals,
  ItemBrowserProvider as Provider
};
export default {
  Display: ItemBrowser,
  Modals: ItemBrowserModals,
  Provider: ItemBrowserProvider
};
